import { useScreenWidth } from './useScreenWidth';

export function menuButtonFocus({ refs, headerVersion }: { refs: any, headerVersion: string }) {
	let buttonToFocus = null;
	const { screenSize } = useScreenWidth();
	const menuButton = refs.menuButtonRef;
	const mobileMenuButton = refs.menuButtonMobileRef;
	const utilityBarRef = refs.utilityBarRef1 || refs.utilityBarRef2;
	const headerNavRef = refs.headerNavRef || refs.headerNavMobileRef;
	if (screenSize.value < 1024 && headerVersion === 'H2') {
		buttonToFocus = mobileMenuButton.$el;
	} else if (headerVersion === 'H5') {
		buttonToFocus = utilityBarRef.menuButtonRef;
	} else if (headerVersion === 'H6') {
		buttonToFocus = headerNavRef.menuButtonRef.$el;
	}
	else {
		buttonToFocus = menuButton.$el;
}
	return buttonToFocus;
}
